module.exports = __webpack_public_path__ + "static/img/icon-03.441b55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/reason/icon-03.png
// module id = Wvmn
// module chunks = 1